import React from 'react';

const About = () => {
    return (
        <div className="about-page">
            <h1>About Me</h1>
            <p>Welcome to my portfolio! I am a passionate software engineer with experience in building impactful technology across diverse industries and scales.</p>
            <p>My journey in tech started with a love for problem-solving and creativity. I enjoy working with modern technologies and continuously learning new skills.</p>
            <p>Feel free to get in touch!</p>
        </div>
    );
};

export default About;